import { render, staticRenderFns } from "./SupportPanelGrid.vue?vue&type=template&id=30f1712c&scoped=true&"
import script from "./SupportPanelGrid.vue?vue&type=script&lang=ts&"
export * from "./SupportPanelGrid.vue?vue&type=script&lang=ts&"
import style0 from "./SupportPanelGrid.vue?vue&type=style&index=0&id=30f1712c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f1712c",
  null
  
)

export default component.exports